import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const useWalmartMarketplaceStatus = () => {
  return useQuery({
    queryKey: ["walmart-marketplace-status"],
    queryFn: async () => await apiClient.getWalmartMarketplaceStatus(),
    staleTime: 5 * 60 * 1000, // 5 minutes - data rarely changes, updated via manual invalidation
  });
};
